import React, {useEffect, useState} from 'react'
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig';
import "./consumerDiscounts.css"
import LeftSide from './consumerDiscountsComponents/LeftSide';
import RightSide from './consumerDiscountsComponents/RightSide';
import Footer from './consumerDiscountsComponents/Footer';
import TermsAndConditionsModal from "./consumerDiscountsComponents/TermsAndConditionsModal"
import Waiting from '../../components/waiting/waiting_v2';
import SuccessfullPayment from '../OnlineCard/SuccessfullPayment';
import DeclinedPayment from '../OnlineCard/DeclinedPayment';


function ConsumerDiscounts({
  platform, 
  payment_token=null,
  userData = null, 
  deliveryNeed= null,
  sourcePage= null,
  deliveryData= null,
  setReqComplete= null,
  disableAllPaymentMethods= null,
  enableAllPaymentMethods= null,
}) {
  const [waiting, setWaiting] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [successData, setSuccessData] = useState({pan:null, cardType:null});
  const [paymentState, setPaymentState] = useState({success: false, failure:false})
  // const [discount, setDiscount] = useState(null);
  const [discounts, setDiscounts] = useState([]);
  const [message, setMessage] = useState("");
  const [amountCents, setAmountCents] = useState(null);
  const [terms, setTerms] = useState("");
  useEffect(() => {
    load_data();
    //load_terms();
  }, [])


  const load_data = () => {
    setWaiting(true);

    let url ="";
    if(platform==="iframe"){
      url = appConfig.getServerUrl() + `/api/acceptance/standalone?payment_token=${payment_token}`;
    }else if(platform==="standalone") {
      url = appConfig.getServerUrl() + `/invoice2/${userData.token}`;
    }
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.get(
        url,
        config
    )
    .then((resp)=>{
      setWaiting(false);
      // setDiscount(resp.data.discount);
      setDiscounts(resp.data.discounts);
      setAmountCents(resp.data.order_amount_cents);
      setMessage(resp.data.message);
    })
    .catch((err)=>{
      setWaiting(false);
    });
  }
  const load_terms = () => {
    setWaiting(true)
    let url = appConfig.getServerUrl() + `/api/acceptance/terms-and-conditions?payment_token=${payment_token}`;
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.get(
        url,
        config
    )
    .then((resp)=>{
      setWaiting(false);
      setTerms(resp.data.terms_condictions);
    })
    .catch((err)=>{
      setWaiting(false);
      // if(err && err.response && err.response.data && err.response.data.message){
      //     if(err.response.data.message.message){
      //         this.setState({waiting: false, current_action: "", current_action_message: err.response.data.message.message})
      //     }else{
      //         this.setState({waiting: false, current_action: "", current_action_message: err.response.data.message})
      //     }
      // }else if(err && err.response && err.response.data && err.response.data.detail){
      //     this.setState({waiting: false, current_action: "", current_action_message: err.response.data.detail})
      // }else{
      //     this.setState({waiting: false, current_action: "", current_action_message: "Oops! Something went wrong. If this problem persists, please contact your service provider."})
      // }
    });
  }
  const toggleModal = () => {
    setModalState(!modalState)
  }
  return paymentState.success ? 
        <SuccessfullPayment amount={successData.amount} pan={successData.pan} cardType={successData.cardType}/> 
      :
      paymentState.failure ? 
        <DeclinedPayment />
      : 
        <div className={platform==="iframe"? "parent" : "consumer-standalone"}>
          <div className="container">
              {waiting === true ? <Waiting /> : (
                  <LeftSide discounts={discounts} message={message} />
              )}
              <RightSide 
                platform={platform}
                totalAmount={amountCents}
                openTermsModal={toggleModal} 
                payment_token={payment_token} 
                userData={userData}
                deliveryNeed={deliveryNeed}
                sourcePage={sourcePage}
                deliveryData={deliveryData}
                setReqComplete={setReqComplete}
                disableAllPaymentMethods={disableAllPaymentMethods}
                enableAllPaymentMethods={enableAllPaymentMethods}
                renderSuccess={(amount, pan, cardType) => {
                  setPaymentState({...paymentState, success:true})
                  setSuccessData({amount, pan, cardType})
                }} 
                renderFailure={() => {setPaymentState({...paymentState, failure:true})}}
              />
              {modalState && (
                <TermsAndConditionsModal modalState={modalState} toggle={toggleModal} terms={terms}/>
              )}
          </div>
          {platform==="iframe" && <Footer />}
        </div>
  
}

export default ConsumerDiscounts